exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".convious-slider__rail{height:.5rem;width:100%;border-radius:inherit}.convious-slider__recommended-tick-marker{opacity:1;position:relative;border:5px solid rgba(0,0,0,0);border-top-color:var(--boy-blue);top:-2rem}.convious-slider.MuiSlider-vertical .MuiSlider-mark{height:1px;width:.5rem}.convious-slider.MuiSlider-vertical .convious-slider__rail{width:.5rem;height:100%}.convious-slider.MuiSlider-vertical .convious-slider__recommended-tick-marker{top:unset;left:-2.2rem;transform:rotate(-90deg)}", ""]);

// exports
